import './components.scss';

const PageFooter = () => {
    return (
      <div className="pageFooter">
        <a href="https://www.instagram.com/egg.tarty" target="_blank" rel="noopener noreferrer" className='footerSocialLink'>instagram: @egg.tarty</a>
        <span>© 2025 Egg Tarty Art Studio</span>
      </div>
    )
  }

  export default PageFooter;